import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { default as React, useState } from "react";
import translate from "../../../i18n/translate";
import { IReschedulePopup } from "../../../interfaces";
import "./MyScheduleSummaryBlock.scss";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../redux/actions";
import RescheduleFirstPage from "./RescheduleFirstPage";
import RescheduleSecondPage from "./RescheduleSecondPage";

let rescheduleWindow: any;

const ReschedulePopup: React.FC<IReschedulePopup> = ({ currentSessionId, openPopup, setPopupState, handleDispatch, prodName }) => {
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [nextButton, setNextButton] = useState("Next");
    const [skipButton, setSkipButton] = useState("Skip");
    const sessionId = currentSessionId;

    const handleClose = () => {
      setPopupState(false);
    };
  
    const nextOnClick = () => {
      if (nextButton === "Next") {
        setNextButton("Done");
        setSkipButton("<");
      } else if (nextButton === "Done") {
        setPopupState(false);
        openRescheduleWindow(sessionId);
      }
    };
    const openRescheduleWindow = (sessionId: number) => {
      let w = 630;
      let h = 440; // default sizes
      if (window.screen) {
        w = window.screen.availWidth - 10;
        h = window.screen.availHeight - 70;
      }
      rescheduleWindow = window.open(
        `${process.env.REACT_APP_TMS_URL}` + "/v2/sessions/" + sessionId + "/reschedule",
        "Reschedule Session",
        "height=" +
        h +
        ",width=" +
        w +
        ",dependent=yes,location=no,menubar=no," +
        "resizable=yes,scrollbars=yes,status=no,toolbar=no"
      );
      rescheduleWindow.focus();
      checkWindowCloseTimer(rescheduleWindow);
    };
    const checkWindowCloseTimer = (learnerWindow: any) => {
  
      const checkTimer: any = setInterval(() => {
        if (learnerWindow.closed) {
          clearInterval(checkTimer);
          const courseId: number = Number(sessionStorage.getItem("courseId")) || 0;
          if (!allInfo.createSessionService.isLoading) {
            dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
          }
          if (!allInfo.tmsLearnerSessions.isLoading) {
            dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
          }
        }
      }, 1000);
    };
    const skipButtonClick = () => {
      if (skipButton === "Skip") {
        setPopupState(false);
        openRescheduleWindow(sessionId);
      } else {
        setNextButton("Next");
        setSkipButton("Skip");
      }
    };
  
    return (
      <Dialog
        open={openPopup}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="intercept-page-dialog"
        
      >
        <DialogTitle className="jss1581" id="alert-dialog-title">
          {translate("myschedule_reschedule_Title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { nextButton === "Next" && <RescheduleFirstPage onClose={handleClose} /> }
            { nextButton === "Done" && <RescheduleSecondPage productName={prodName} onClose={handleClose} /> }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="jss1600">
            <Button
              size="medium"
              onClick={() => skipButtonClick()}
              id="skip-intercept-page"
              data-testid="skip-intercept-page-ID"
              tabIndex={0}
              className="skip-button"
            >
              <span className={skipButton === "Skip" ? "jss1603" : "jss1631"}>
                <span>{skipButton === "Skip" ? translate("myschedule_rechedule_skipButton") : skipButton}</span>
              </span>
              <span className="jss1631"></span>
            </Button>
            <Button
              color="primary" variant="contained" size="medium"
              onClick={() => nextOnClick()}
              id="intercept-next-button"
              data-testid="intercept-next-button-ID"
              tabIndex={0}
              className="next-intercept-page-button"
            >
              <span className="jss1639">
                <span>
                  {nextButton === "Done"
                    ? translate("myschedule_rechedule_next_done")
                    : translate("button_next")}
                </span>
              </span>
              <span className="jss1667"></span>
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    )
  };

  export default ReschedulePopup;